var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"green lighten-4",attrs:{"fluid":"","align-center":"","justify-center":"","fill-height":""}},[_c('v-progress-circular',{attrs:{"size":50,"color":_vm.corSelecionada,"indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }